import { OfficialReportType } from '@/types/officialReport'

export const isLateOfficialReportType = (type: OfficialReportType): boolean =>
    [OfficialReportType.LateDeparture, OfficialReportType.LateTakeover].includes(type)

export const isHeadwayOfficialReportType = (reportType: OfficialReportType): boolean =>
    reportType === OfficialReportType.Headway

export const isGenericOfficialReportType = (reportType: OfficialReportType): boolean =>
    reportType === OfficialReportType.Generic
